import { render, staticRenderFns } from "./MultiSelectMenuItem.vue?vue&type=template&id=2822b310&scoped=true"
import script from "./MultiSelectMenuItem.vue?vue&type=script&lang=js"
export * from "./MultiSelectMenuItem.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectMenuItem.vue?vue&type=style&index=0&id=2822b310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822b310",
  null
  
)

export default component.exports